import React from 'react';

const load = (store, container, component, route) => {
  return class extends React.Component {
    componentDidMount() {
      store.dispatch({
        type: 'route.mounted',
        route,
      });
    }

    render() {
      if (component) {
        const children = React.createElement(component, this.props);
        return React.createElement(container, this.props, children);
      }
      return React.createElement(container, this.props);
    }
  };
};

export default load;



// WEBPACK FOOTER //
// ./src/components/load.js